import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
//import VueYandexMetrika from 'vue-yandex-metrika';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

import '../src/assets/css/site.css';
import '../src/assets/css/bvi-theme.css';
import '@fortawesome/fontawesome-free/js/all.js';
//import 'bootstrap';

// Версия для слабовидящих
//import 'bvi/dist/css/bvi.min.css';
//import 'bvi/dist/js/bvi.min.js';

import axios from 'axios';
//axios.defaults.baseURL = '/RnUchet/api/';
axios.defaults.baseURL = '/api/';
axios.defaults.maxContentLength = 1024 ** 3;
axios.defaults.withCredentials = true;

Vue.config.productionTip = false;

/*
Vue.use(VueYandexMetrika, {
  id: 80411977,
  router: router,
  env: process.env.NODE_ENV
  //env: 'production'//process.env.NODE_ENV
});
*/

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
